/* unplugin-vue-components disabled */import script from "./hospitalPicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./hospitalPicker.vue?vue&type=script&lang=ts&setup=true"

import "./hospitalPicker.vue?vue&type=style&index=0&id=0a347c14&lang=less&scoped=true"

import exportComponent from "/data/liulv-h5/quantum-technology/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a347c14"]])

export default __exports__